// Derived from the generated GraphQL operations (codegen output), then hand-trimmed.
// There is no codegen config in this app — maintain this file manually and keep it
// in sync with applications/account/backend/appsync/schema.graphql.
// Trimmed for the Account app: only the operations it uses are kept.

export const updateUserDetails = /* GraphQL */ `
  mutation UpdateUserDetails($input: UserDetailsInput!) {
    updateUserDetails(input: $input) {
      statusCode
      __typename
    }
  }
`;
export const passwordReset = /* GraphQL */ `
  mutation PasswordReset {
    passwordReset
  }
`;
// NOTE: The inquiry screen is not needed in the account application, so this code is commented out.
// export const saveInquiry = /* GraphQL */ `
//   mutation SaveInquiry($input: InquiryInput!) {
//     saveInquiry(input: $input) {
//       name
//       email
//       tel
//       subject
//       content
//       companyName
//       __typename
//     }
//   }
// `;
